/* frontend/src/pages/VehicleEdit.js */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import VehicleFormWithPlaca from './VehicleFormWithPlaca.jsx';
import api from '../api';

// Shadcn UI components
import { Spinner } from '../components/ui/spinner';

export default function VehicleEdit() {
  const { id } = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  /* carregar veículo */
  useEffect(() => {
    api.get(`/veiculos/${id}`).then(r => setData(r.data));
  }, [id]);

  /* estado de loading */
  if (!data) {
    return (
      <div className="container mx-auto px-4 mt-4 mb-6">
        <div className="min-h-[400px] flex flex-col items-center justify-center gap-4 bg-background border rounded-lg p-6">
          <Spinner className="h-10 w-10 text-primary" />
          <p className="text-muted-foreground">
            {t('vehicleEdit.loadingVehicleData')}
          </p>
        </div>
      </div>
    );
  }

  /* modo edição */
  return <VehicleFormWithPlaca mode="edit" defaults={data} id={id} />;
}
